import { render, staticRenderFns } from "./HeaderDetail.vue?vue&type=template&id=015298dd&scoped=true"
import script from "./HeaderDetail.vue?vue&type=script&lang=js"
export * from "./HeaderDetail.vue?vue&type=script&lang=js"
import style0 from "./HeaderDetail.vue?vue&type=style&index=0&id=015298dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015298dd",
  null
  
)

export default component.exports